module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_selady-04eab23e673d3dbe880c0228edd0a906.svg";